<template>
  <div class="h100vh-116">
    <div class="h100vh-140">
      <ejs-grid ref='grid' :dataSource="data" :allowResizing='true' :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :actionComplete='actionComplete' :allowPaging='true' :pageSettings="page" height="calc(100% - 0px)">
        <e-columns>
          <e-column type='checkbox' headerText='impu' width='40' textAlign='Center'></e-column>
          <e-column field='impu' :headerText="$t('SubscriberIms.userNo')" width='150' textAlign='Center'></e-column>
          <e-column field='username' :headerText="$t('SubscriberIms.userName')" width='150' textAlign='Center'></e-column>
          <e-column field='rtttype' :headerText="$t('SubscriberIms.rtttype')" :formatter='rtttypeFormat' width='150' textAlign='Center'></e-column>
          <e-column v-if='showSubStatus' field='substatus' :headerText="$t('SubscriberIms.substatus')" :formatter='substatusFormat' width='150' textAlign='Center'></e-column>
          <e-column v-if='showRegStatus' field='regstatus' :headerText="$t('SubscriberIms.regstatus')" :formatter='regstatusFormat' width='150' textAlign='Center'></e-column>
          <e-column v-if='showUserenable' field='userenable' :headerText="$t('SubscriberIms.userenable')" :formatter='userenableFormat' width='150' textAlign='Center'></e-column>
          <e-column field='createtime' :headerText="$t('SubscriberIms.createtime')" format='yyyy-MM-dd HH:mm:ss' type='dateTime' width='150' textAlign='Center'></e-column>
          <e-column field='activetime' :headerText="$t('SubscriberIms.activetime')" format='yyyy-MM-dd HH:mm:ss' type='dateTime' width='150' textAlign='Center'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref="userPager" @click='getGridData(node, false)' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
    <CustomDialog ref='addUserPage' :element='dialog.element.eleAddUser' :styles='dialog.styles' :messages='dialog.messages.addUser'>
      <template v-slot:dialog-content>
        <AddUserDialog ref='addUser' opCode='add'></AddUserDialog>
      </template>
    </CustomDialog>
    <ModUserDialog ref='modUserPage' :element='dialog.element.eleModUser' :styles='dialog.styles' :messages='dialog.messages.modUser'>
      <template v-slot:dialog-content>
        <AddUserDialog ref='modUser' opCode='mod' :node="node"></AddUserDialog>
      </template>
    </ModUserDialog>
    <CustomDialog ref='addUserMemberPage' :element='dialog.element.eleAddUserMember' :styles='dialog.stylesUserList' :messages='dialog.messages.addUserMember'>
      <template v-slot:dialog-content>
        <AddUserMemberDialog ref='addUserMember' opCode='addMember' :msgid="taskMsgid.addUserMemberMsgid" :neid="info.neid" :node="node"></AddUserMemberDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='modUserMemberPage' :element='dialog.element.eleModUserMember' :styles='dialog.stylesMemeberList' :node="node" :messages='dialog.messages.qryUserMember'>
      <template v-slot:dialog-content>
        <QryUserMemberDialog ref='modUserMember' :msgid="taskMsgid.modGroupMemberMsgid" :neid="info.neid" :node="node" :neversion="neversion"></QryUserMemberDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='qryImsUserPage' :element='dialog.element.eleQryImsUser' :styles='dialog.stylesSearch' :messages='dialog.messages.search'>
      <template v-slot:dialog-content>
        <ImsUserSearchDialog ref='qryImsUser' :showOption='showUserenable' ></ImsUserSearchDialog>
      </template>
    </CustomDialog>
    <div class="h-system-hide-upload">
      <ejs-uploader ref="importUser" autoUpload="false"  allowedExtensions=".xls,.xlsx" :multiple="false" id="file" :selected="onFileSelect"></ejs-uploader>
    </div>
    <LayerDialog ref='layerDialog' :element='dialog.element.layerTip'>
    </LayerDialog>
    <CustomDialog ref='dialogListPage' :element='dialog.element.eleDialogList' :styles='dialog.stylesWithIndex'>
      <template v-slot:dialog-content>
        <DialogList ref='dialogList'></DialogList>
      </template>
    </CustomDialog>
    <DeviceAdapter ref='devAdapter' ></DeviceAdapter>
  </div>
</template>
<script>
import md5 from 'js-md5';
import XLSX from 'xlsx';
import CustomDialog from '../../../common/CustomDialog';
import ModUserDialog from './ModUserDialog';
import AddUserDialog from './dialog/AddImsUserDialog';
import DialogList from '../../util/tipDialog/DialogList';
import LayerDialog from '../LayerDialog';
import AddUserMemberDialog from './dialog/AddUserMemberDialog';
import QryUserMemberDialog from './dialog/QryUserMemberDialog.vue';
import ImsUserSearchDialog from './dialog/ImsUserSearchDialog';
import { EventBus } from '../../../../plugins/eventBus';
import { Resize } from '@syncfusion/ej2-vue-grids';
import DeviceAdapter from './device/DeviceAdapter';

export default {
  name: 'ImsUserTable',
  components: {
    CustomDialog,
    ModUserDialog,
    AddUserDialog,
    DialogList,
    LayerDialog,
    AddUserMemberDialog,
    QryUserMemberDialog,
    ImsUserSearchDialog,
    DeviceAdapter,
  },
  provide: {
    grid: [Resize]
  },
  data() {
    return {
      node: '',
      usernumList: [],
      dataForm: [],
      showSubStatus: true,
      showRegStatus: true,
      showUserenable: false,
      neversion: '',
      uploader: {
        path: {
          saveUrl: '/lte/ems/subscriber/imsunms/importData',
          removeUrl: ''
        },
        autoUpload: false
      },
      data: {},
      dialPlanMap: {
        4: 'DIAL_PLAN_DMR',
        5: 'DIAL_PLAN_CPS_P3',
        6: 'DIAL_PLAN_ZJ'
      },
      batchAddRes: [],
      neidAndDialplanMap: new Map(),
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      info: {
        msgid: '',
        neid: '',
        netype: '',
        neversion: ''
      },
      zoneVo: {
        neid: '',
        moname: 'TcfDialPlanCfg',
        name: 'DialPlan'
      },
      dialPlanList: [4,5,6], // 网管只支持p3\dmr\浙江拨号方案
      dialPlan: '',
      taskMsgid: {
        addUserMsgid: '27833', // 添加用户命令码
        modUserMsgid: '27834', // 修改用户命令吗
        delUserMsgid: '27835', // 删除用户命令码
        qryUserMsgid: '27836', // 查询用户命令吗
        addUserMemberMsgid: '27828', // 添加隶属关系命令码
        modUserMemberMsgid: '27829', // 修改隶属关系命令吗
        delUserMemberMsgid: '27830', // 删除隶属关系命令码
        qryUserMemberMsgid: '27831', // 查询隶属关系命令吗
        qryUserListMsgid: '27836'
      },
      dateFormat: {
        type: 'date', format: 'yyyy-MM-dd hh:mm:ss'
      },
      passwordbefore: '',
      realmbefore: '',
      lteimsibefore: '',
      qrySearchBak: null,
      vo: {
        flag: 0,
      },
      chooseCount: 0,
      dialog: {
        tipInfos: '',
        styles: {
          width: '830px',
          height: '770px',
          visible: false,
          model: true
        },
        stylesUserList: {
          width: '65%',
          height: '85%',
          visible: false,
          model: true,
          zIndex: 1000
        },
        stylesWithIndex: {
          width: '830px',
          height: '770px',
          visible: false,
          model: true,
          zIndex: 1000
        },
        stylesMemeberList: {
          width: '65%',
          height: '72%',
          visible: false,
          model: true
        },
        stylesSearch: {
          width: '30%',
          height: '60%',
          visible: false,
          model: true
        },
        element: {
          eleDialogList: {
            target: this.$refs.usertable,
            refName: 'dialogList',
            buttonGroup: [
              {
                click: this.closeDialogListTipPage,
                buttonModel: { content:this.$t('SubscriberIms.confirm') }
              }
            ],
            title: this.$t('SubscriberIms.logTitle'),
            isClose: true,
          },
          eleAddUser: {
            target: this.$refs.usertable,
            refName: 'eleAddUser',
            buttonGroup: [
              {
                click: this.closeAddImsUserPage,
                buttonModel: { content: this.$t('SubscriberIms.cancel') }
              },
              {
                click: this.saveAddImsUserPage,
                buttonModel: {
                  content: this.$t('SubscriberIms.confirm'),
                  isPrimary: true
                }
              }
            ],
            title: this.$t('SubscriberIms.addUser'),
            isClose: true
          },
          eleModUser: {
            target: this.$refs.usertable,
            refName: 'eleModUser',
            buttonGroup: [
              {
                click: this.closeModImsUserPage,
                buttonModel: { content: this.$t('SubscriberIms.cancel') }
              },
              {
                click: this.saveModImsUserPage,
                buttonModel: {
                  content: this.$t('SubscriberIms.confirm'),
                  isPrimary: true
                }
              }
            ],
            title: this.$t('SubscriberIms.modUser'),
            isClose: true
          },
          eleAddUserMember: {
            target: this.$refs.userstable,
            refName: 'eleAddUserMember',
            buttonGroup: [
              {
                click: this.closeAddImsUserMemberPage, buttonModel: { content: this.$t('SubscriberIms.cancel') }
              },
              {
                click: this.saveAddImsUserMemberPage, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
              }
            ],
            title:this.$t('SubscriberIms.addGroupMember'),
            isClose: true
          },
          eleModUserMember: {
            target: this.$refs.userstable,
            refName: 'eleModUserMember',
            buttonGroup: [
              {
                click: this.closeModImsGroupMemberPage,
                buttonModel: { content:this.$t('SubscriberIms.close') }
              }
            ],
            title:this.$t('SubscriberIms.qryGroupMember'),
            isClose: true
          },
          eleQryImsUser: {
            target: this.$refs.usertable,
            refName: 'qryImsUser',
            buttonGroup: [
              {
                click: this.closeQryImsUserPage, buttonModel: { content: this.$t('SubscriberIms.cancel') }
              },
              {
                click: this.qryImsUserPage, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
              }
            ],
            title: this.$t('SubscriberIms.qryAdvance'),
            isClose: true
          },
          layerTip: {
            target: this.$refs.usertable,
            refName: 'layerDialog',
            buttonGroup: [
              {
                click: this.closeLayerTipPage,
                buttonModel: { content: this.$t('SubscriberIms.confirm') }
              }
            ],
            title:this.$t('SubscriberIms.reminder'),
            isClose: true,
          },
        },
        messages: {
          addUser: {
            title:this.$t('SubscriberIms.addUser')
          },
          modUser: {
            title:this.$t('SubscriberIms.modUser')
          },
          addUserMember: {
            title: this.$t('SubscriberIms.warn')
          },
          qryUserMember: {
            title: this.$t('SubscriberIms.addUserMember')
          },
          search: {
            title: this.$t('SubscriberIms.qryUserMember')
          }
        },
      },
      gridTypeEnum: {
        rtttype: [,,this.$t('SubscriberIms.rtttype2'),,this.$t('SubscriberIms.rtttype4'),this.$t('SubscriberIms.rtttype5'),this.$t('SubscriberIms.rtttype6'),,this.$t('SubscriberIms.rtttype8')],
        rtttype2: [,this.$t('SubscriberIms.rtttype1'),this.$t('SubscriberIms.rtttype2'),this.$t('SubscriberIms.rtttype3'),this.$t('SubscriberIms.rtttype4'),this.$t('SubscriberIms.rtttype5'),this.$t('SubscriberIms.rtttype6_2'),,this.$t('SubscriberIms.rtttype8')],
        substatus:[this.$t('SubscriberIms.substatus0'),this.$t('SubscriberIms.substatus1'),this.$t('SubscriberIms.substatus2')],
        regstatus:[this.$t('SubscriberIms.regstatus0'),this.$t('SubscriberIms.regstatus1')],
        userenable:[this.$t('SubscriberIms.userenable0'),this.$t('SubscriberIms.userenable1')]
      }
    };
  },
  methods: {
    rtttypeFormat(grids,data){
      const $this = this;
      if($this.node.neNode) {
        if($this.node.neNode.softwareVersion.indexOf("_V22") > 0) {
          return this.gridTypeEnum.rtttype2[data.rtttype];
        }
      }
      return this.gridTypeEnum.rtttype[data.rtttype];
    },
    substatusFormat(grids,data){
      return this.gridTypeEnum.substatus[data.substatus];
    },
    regstatusFormat(grids,data){
      return data.rtttype === 8?"--":this.gridTypeEnum.regstatus[data.regstatus];
    },
    userenableFormat(grids,data){
      return this.gridTypeEnum.userenable[data.userenable];
    },
    actionComplete() {
      this.$refs.grid.selectRow(0, true);
      this.$refs.grid.selectRow(0, true);
    },
    clearGridData() {
      const $this = this;
      $this.data = [];
      $this.page.pageCount = 0;
      $this.page.totalCount = 0;
      $this.page.pageCount = 0;
      $this.info.neid = '';
      $this.info.vpnid = '';
      $this.info.netype = '';
    },
    setNeSoftwareVersion(neversion) {
      this.neversion = neversion;
      this.$refs.devAdapter.setNeSoftwareVersion(neversion);
      if(neversion.indexOf("_V22") > 0) {
        this.showUserenable = true;
        this.showSubStatus  = false;
        this.showRegStatus  = false;
        this.dialPlanMap[5] = 'DIAL_PLAN_CPSX_P3';
      } else {
        this.showUserenable = false;
        this.showSubStatus  = true;
        this.showRegStatus  = true;
        this.dialPlanMap[5] = 'DIAL_PLAN_CPS_P3';
      }
    },
    getGridData(node, isFirstPage = true) {
      const $this = this;
      $this.node  = node;

      if ($this.node !== '' && typeof $this.node !== 'undefined') {

        $this.node.neNode && $this.setNeSoftwareVersion($this.node.neNode.softwareVersion);

        const array         = $this.node.id.split('_');
        const neid          = array[0];
        const vpnid         = array[2];
        const vpnclass      = parseInt($this.node.level, 0) - 1;

        $this.info.neid     = neid;
        $this.info.vpnid    = vpnid;
        $this.info.vpnClass = vpnclass;
        $this.vo.vpnid      = vpnid;
        $this.vo.vpnClass   = vpnclass;
        $this.vo.flag       = 0;
        $this.vo.vpnname    = $this.node.text;
        $this.page.pageNo   = isFirstPage ? 1 : this.$refs.userPager.ej2Instances.currentPage;

        const paramTotal = {
          vo: {
            ...$this.vo,
            ...$this.qrySearchBak,
          },
          info: {
            msgid: $this.taskMsgid.qryUserMsgid,
            neid: $this.info.neid
          },
          page: $this.page
        };

        // this.$refs.devAdapter.getQryUserRecords();

        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramTotal).then((response) => {
          if (response.data.errorCode !== '0') {
            EventBus.$emit('toast', {type: 'warning', content: response.data.errorString});
          } else {
            const res = response.data.resultVal;
            if (response.data.resultVal.result === 0) {
              res.resultList.forEach(item => {
                const createtime = item.createtime * 1000;
                const activetime = item.activetime * 1000;
                item.createtime = createtime;
                if(activetime === 0){
                  item.activetime = '--'
                }
                else {
                  item.activetime = activetime;
                }
              });
            }
            $this.data = res.resultList;
            //$this.page.pageNo = res.page;
            $this.page.totalCount = res.countrsp;
            // 临时解决6361单：组数据都删除，再添加，无法选中全选框
            setTimeout(()=> {
              if (res.countrsp === 0) { // 没有数据---组件会将domtokenlist增加e-checkbox-disabled属性
                const temp = $this.$refs.grid.$el.childNodes[2].children[0].children[0].children[1].children[0].children[0].children[0].children[0].classList;
                if (temp.length > 2) {
                  temp.remove('e-checkbox-disabled');
                }
              }
            }, 100);
            //$this.page.pageCount = Math.ceil(res.countrsp / $this.page.pageSize);
          }
        });

      } else {
        $this.info.neid  = '';
        $this.vo.vpnid   = '';
        $this.vo.vpnname = '';
      }
    },
    isChooseNe() {
      if (typeof (this.vo.vpnid) === 'undefined' || this.vo.vpnid === '') {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.checkVpnTip')});
        return false;
      }
      return true;
    },
    getParams() {
      const $this = this;
      let qryParams = null;
      qryParams = {
        page: {
          pageNo: $this.page.pageNo,
          pageSize: $this.page.pageSize
        },
        info: $this.info,
        vo: $this.vo
      };
      return qryParams;
    },

    getCheckedData(selectOnly, type) {
      let selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.noCheckDataTip')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.checkDataMoreTip')});
        return false;
      }
      if (selectOnly && selectedRecords.length === 1 && type) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.checkDateLessTip')});
        return false;
      }
      if (type && selectOnly) { // 多选 并判断类型
        const tempSelectData = selectedRecords[0][type];
        try {
          selectedRecords.forEach(item => {
            console.log(tempSelectData, item[type]);
            if (item[type] !== tempSelectData) {
              EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.notModWithDifTypeTip')});
              selectedRecords = [];
              throw new Error('ending');
            }
          });
        } catch (e) { }
      }
      return selectedRecords;
    },

    getCheckedVals(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      // const grpnum = [];
      const checkedData = this.getCheckedData(selectOnly);
      // for (let i = 0; i < checkedData.length; i++) {
      //   grpnum.push(checkedData[i].grpnum);
      // }
      return checkedData.length === 0 ? false : checkedData;
    },
    // 同种组类型支持多选
    getCheckedValsWithType(selectOnly = false, type = false) {
      // x-> false: 不支持多选   true: 支持多选
      // type-> 组类型
      // const grpnum = [];
      const checkedData = this.getCheckedData(selectOnly, type);
      // for (let i = 0; i < checkedData.length; i++) {
      //   grpnum.push(checkedData[i].grpnum);
      // }
      return checkedData.length === 0 ? false : checkedData;
    },

    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },
    getParamsForNewPage(opCode) {
      const params = {};
      params.dialPlan = this.dialPlan;
      params.neid = this.info.neid;
      params.vpnid = this.info.vpnid;
      params.vpnclass = this.info.vpnClass;
      params.vpnname = this.vo.vpnname;
      params.opCode = opCode;
      params.neversion = this.neversion;
      return params;
    },
    getPasswordMd5(item, type) {
      if(item['password[confirm]'] !== item['password[origin]'])
        return false;
      if (type === 'add') {
        if (item.lteimsi !== '') item.password = md5(`${item.impu}:${item.realm.replace('@', '')}:${item['password[confirm]']}:${item.lteimsi}`);
        else item.password = md5(`${item.impu}:${item.realm.replace('@', '')}:${item['password[confirm]']}`);
      } else if (type === 'batchAdd') {
        if (item.lteimsi !== '') item.password = md5(`${item.impu}:${item.realm.replace('@', '')}:${item['password[confirm]']}:${item.lteimsi}`);
        else item.password = md5(`${item.impu}:${item.realm.replace('@', '')}:${item['password[confirm]']}`);
      }
      return item;
    },

    /**
     * 打开/关闭/保存  添加用户页面
     */

    async openAddImsUserPage(opCode) {
      if (this.isChooseNe() === false) {
        return;
      }

      this.opCode = opCode;
      // 先判断拨号方案--存在则继续操作；不存在则给出提示
      if (this.neidAndDialplanMap.size > 0 && this.neidAndDialplanMap.get(this.info.neid)) {
        this.dialPlanExistThenDo(opCode);
        return;
      }

      const infoMap = {
        vo: { 0: this.info.neid, 1: this.zoneVo.moname, 2: this.zoneVo.name },
        info: { neid: this.info.neid, operation: 'getDialplan'},
      };
      let dialPlan  = null;

      await this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', infoMap).then((response) => {
        if (response.status !== 200) {
          this.$refs.addUserPage.close();
          EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.requestResTip')});
        } else {
          // 获取拨号方案成功---网管只支p3-5、dmr=4、浙江拨号方案=6
          if (response.data === '' || response.data.errorCode !== '0') {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.qryDialPlanFailTip')});
            return;
          }
          if (response.data.resultVal && response.data.resultVal.length === 0) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.noDialTip')});
            return;
          }
          dialPlan = JSON.parse(response.data.resultVal);
        }
      });

      let supportedDialPlan = false;
      this.dialPlanList.filter(item => {
        if (dialPlan[0] === this.dialPlanMap[item]) {
          // PoCV2.2不支持浙江拨号方案
          if(dialPlan[0] === 'DIAL_PLAN_ZJ' && this.neversion && this.neversion.indexOf("_V22") > 0) {
            supportedDialPlan = false;
          } else {
            supportedDialPlan = true;
            this.dialPlan = parseInt(item, 0);
            this.neidAndDialplanMap.set(this.info.neid, this.dialPlan);
          }
        }
      });
      if (supportedDialPlan) {
        this.dialPlanExistThenDo(opCode);
      } else {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.notSuppoDialTip')});
        return false;
      }
    },
    dialPlanExistThenDo(opCode) {
      const param = { msgid: this.taskMsgid.addUserMsgid, neid: this.info.neid };
      this.$axios.post('/lte/ems/subscriber/imsunms/getParamJson', param).then((res) => {
        if (res.status !== 200) {
          this.$refs.addUserPage.close();
          EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.requestResTip')});
        } else {
          this.batchAddRes = res;
          this.$refs.addUser.mainHandler([], this.getParamsForNewPage(opCode), res);
          this.$refs.addUser.showLoadding(500);
          this.$refs.addUserPage.show();
        }
      });
    },
    checkVpnid(vodata) {
      if (vodata.vpnid === '' || vodata.vpnid === 0 ) {
        vodata.vpnid = null;
      }
      return vodata;
    },
    batchAddProcForPoC22(item) {
      if(this.neversion.indexOf("_V22") > 0) {
        item.impi  = item.impu;
        item.subid = item.impu;
        item.substatus = 0;
        item.subname = '';
        item.serviceprofileid = item.impu;
      }
      return item;
    },
    closeAddImsUserPage() {
      this.$refs.addUserPage.close();
    },
    saveAddImsUserPage() {
      const vodata = this.$refs.addUser.getDatas();
      if(!vodata) return;

      this.info.msgid = this.taskMsgid.addUserMsgid;
      this.checkVpnid(vodata);

      if (this.opCode === 'add') {
        this.getPasswordMd5(vodata, this.opCode);
        const logParam = {
          module: 'res.subscriber#res.subscriber_ims#subscriber.imsUser',
          execFunName:'subscriber.addUser',
          exectype: 1,
          execData:[vodata]
        };
        const paramMap = {};
        paramMap.vo   = vodata;
        paramMap.info = this.info;
        paramMap.log  = logParam;
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramMap).then((response) => {
          if (response.status === 200) {
            this.commonHandlerResponse(response, 'addUserPage');
          } else {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
          }
        });
      } else if (this.opCode === 'batchAdd') {
        const { opCount, impu, vpnid, createtime } = vodata;
        if(opCount > 1000){
          EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.toomuchUsers')});
          return;
        }
        this.$loading.showLoadding(this.$t('SubscriberIms.batchAddUserTip'),this.$t('SubscriberIms.waitTip'));
        const fieldNameSet = [];
        this.batchAddRes.data.resultVal.forEach(item => {
          fieldNameSet.push(item.name);
        });
        const params = [];
        for (let i = 0; i < opCount; i++) {
          const item = {};
          fieldNameSet.forEach((name) => {
            if ("modeltype" == name) {
              if ("6" == vodata.rtttype) {
                item[name] = "1" == vodata[name] ? "PNC360" : "";
              }
            } else {
              item[name] = vodata[name];
            }
          });
          item.opCount = 1;
          params[i] = item;
        }
        params.forEach((item, index) => {
          if(this.dialPlan == this.dialPlanList[0]) {
            item.impu = this.addZero(parseInt(impu, 0) + index + '', 7);
          } else {
            item.impu  = parseInt(impu, 0) + index;
          }
          item.vpnid = vpnid;
          item.createtime = createtime;
          this.batchAddProcForPoC22(item);
          this.getPasswordMd5(item, this.opCode);
        });
        const logParam = {
          module: 'res.subscriber#res.subscriber_ims#subscriber.imsUser',
          execFunName:'subscriber.addUser',
          exectype: 1,
          execData:params
        };
        const paramBatch = {
          vo: {
            0: {
              vo: params,
              info: { msgid: this.taskMsgid.addUserMsgid, neid: this.info.neid }
            }
          },
          info: { operation: 'bacthOperate' },
          log: logParam
        };
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramBatch,{timeout: 1000 * 60 * 31}).then((response) => {
          if (response.status === 200) {
            const _showDatas = [];
            for (let count = 0; count < vodata.opCount; count++) {
              _showDatas[count] = { operObj: this.addZero(parseInt(vodata.impu, 0) + count +'', 7) };
            }
            if(response.data.resultVal !==  null){
              response.data.resultVal.forEach((item, index) => {
                _showDatas[index].operResult = item.display;
                _showDatas[index].operCode = item.code;
              });
              this.$loading.hideLoadding();
              this.$refs.addUserPage.clear();
              this.$refs.addUserPage.close();
              this.$refs.dialogListPage.show();
              this.$refs.dialogList.addOperetionResultList(_showDatas);
              this.getGridData(this.node);
            }
            else{
              this.$loading.hideLoadding();
              this.$refs.addUserPage.clear();
              this.$refs.addUserPage.close();
              this.getGridData(this.node);
            }
          }
          else {
            this.$loading.hideLoadding();
            EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.requestResTip')});
          }
        });
      }
    },
    addZero(value, len) {
      while (value.length < len) { // 需要前面补0
        value = `0${value}`;
      }
      return value;
    },
    setInfo(msgid) {
      return {
        msgid,
        neid: this.info.neid,
      };
    },
    commonHandlerResponse(response, closePage) {
      if (response.data.resultVal && response.data.resultVal.length > 0) {
        if (response.data.resultVal[0].code.split('.')[2] === '0') {
          EventBus.$emit('toast', { type: 'success', content: response.data.resultVal[0].display });
          this.$refs[closePage].clear();
          this.$refs[closePage].close();
          this.getGridData(this.node);
        } else {
          EventBus.$emit('toast', { type: 'warning', content: response.data.resultVal[0].display });
        }
      } else {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.resultReturnFailedTip') });
      }
    },
    /**
     * 打开/关闭/保存  修改用户页面
     */
    openModImsUserPage(opCode) {
      let userid = false;
      if (opCode === 'mod') {
        userid = this.getCheckedValsWithType(false, false);
      } else if (opCode === 'batchMod') {
        userid = this.getCheckedValsWithType(true, 'rtttype');
      }
      if (userid) {
        this.opCode = opCode;
        this.usernumList = userid;
        const param = { msgid: '27834', neid: this.info.neid };
        this.$axios.post('/lte/ems/subscriber/imsunms/getParamJson', param).then((response) => {
          if (response.status !== 200) {
            this.$refs.modUserPage.clear();
            this.$refs.modUserPage.close();
            EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.requestResTip')});
          } else {
            this.batchModRes = response;
            this.$refs.modUser.mainHandler(this.$refs.grid.getSelectedRecords(), this.getParamsForNewPage(opCode), response);
            this.$refs.modUser.showLoadding(500);
            this.$refs.modUserPage.show();
          }
        });
      }
    },
    closeModImsUserPage() {
      this.$refs.modUserPage.clear();
      this.$refs.modUserPage.close();
    },
    async saveModImsUserPage() {
      this.info.msgid = '27834';
      const vodata = this.$refs.modUser.getDatas();
      if(!vodata) return;

      this.checkVpnid(vodata);

      if (this.opCode === 'batchMod') {
        const serviceProfileInfoFlag = this.$refs.modUser.checkboxMap['serviceProfileInfo'];
        const supplementaryInfoFlag = this.$refs.modUser.checkboxMap['supplementaryInfo'];

        // 用户数据赋值
        this.$loading.showLoadding(this.$t('SubscriberIms.batchModUserTip'),this.$t('SubscriberIms.waitTip'));

        const userlist = this.$refs.grid.getSelectedRecords();
        const userlistNew = await this.$refs.devAdapter.getBatchModUserRecords(this.getParams(), userlist);

        const fieldNameSet = [];
        this.batchModRes.data.resultVal.forEach(item => {
          if (item.couldBatchMod && ((item.groupBy === 'serviceProfileInfo' && serviceProfileInfoFlag)
            || (item.groupBy === 'supplementaryInfo' && supplementaryInfoFlag)
            || (item.name !== 'vpnid' && item.groupBy === 'impuinfo' && this.$refs.modUser.checkboxMap[item.name])
            || (item.name === 'vpnid' && vodata.vpnid !== null && item.groupBy === 'impuinfo' && this.$refs.modUser.checkboxMap[item.name]))) {
            fieldNameSet.push(item.name);
          }
        });
        const _showData = [];
        userlistNew.forEach(item => {
          delete item.modeltype;
          item.opCount = 1;
          if (item.activetime === '--') {
            item.activetime = 0;
          }
          item.createtime = item.createtime / 1000;
          const showData = {};
          showData.operObj = item.impu;
          _showData.push(showData);
          fieldNameSet.forEach((name) => {
            item[name] = vodata[name];
          });
        });
        const logParam = {
          module: 'res.subscriber#res.subscriber_ims#subscriber.imsUser',
          execFunName: 'subscriber.modUser',
          exectype: 2,
          execData: userlistNew,
        };
        const paramBatch = {
          vo: {
            0: {
              vo: userlistNew,
              info: { msgid: this.taskMsgid.modUserMsgid, neid: this.info.neid }
            }
          },
          info: { operation: 'bacthOperate' },
          log: logParam,
        };

        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramBatch).then((response) => {
          if (response.status === 200) {
            if(response.data.resultVal !==  null){
              response.data.resultVal.forEach((item, index) => {
                _showData[index].operResult = item.display;
                _showData[index].operCode = item.code;
              });
              this.$loading.hideLoadding();
              this.$refs.modUserPage.clear();
              this.$refs.modUserPage.close();
              this.$refs.dialogListPage.show();
              this.$refs.dialogList.setTotalCount(this.usernumList.length);
              this.$refs.dialogList.addOperetionResultList(_showData);
              this.getGridData(this.node);
            }
            else{
              this.$loading.hideLoadding();
              this.$refs.addUserPage.clear();
              this.$refs.addUserPage.close();
              this.getGridData(this.node);
            }
          } else {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.requestResTip')});
          }
        });
      } else if (this.opCode === 'mod') {

        const logParam = {
          module: 'res.subscriber#res.subscriber_ims#subscriber.imsUser',
          execFunName:'subscriber.modUser',
          exectype:1,
          execData:[vodata]
        };

        const paramMap = { info: this.info, vo: vodata, log: logParam };
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramMap).then((response) => {
          if (response.status === 200) {
            this.commonHandlerResponse(response, 'modUserPage');
          } else {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.requestResTip')});
          }
        });
      }
    },

    /**
     * 删除用户
     */
    delImsUsers() {
      const userid = this.getCheckedValsWithType(true, false);
      if (userid) {

        this.$layer.confirm({
          title: this.$t('SubscriberIms.reminder'),
          msg: this.$t('SubscriberIms.deleteConfirm'),
          btn2: {
            msg: this.$t('SubscriberIms.confirm'),
            func: () => {
              this.info.msgid = this.taskMsgid.delUserMsgid;

              const param  = { userid, info: this.info };
              const record = this.$refs.devAdapter.getDelUserRecords(param);
              const { paramMap, resultObj } = record;

              this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramMap).then((response) => {
                  this.$refs.addUserPage.clear();
                  this.$refs.addUserPage.close();
                  this.$refs.dialogListPage.show();
                  response.data.resultVal.forEach((item, index) => {
                    resultObj[index].operResult = item.display;
                    resultObj[index].operCode = item.code;
                  });
                  this.$refs.dialogList.addOperetionResultList(resultObj);
                  this.getGridData(this.node);
              });
            }
          },
          btn1: {
            msg: this.$t('SubscriberIms.cancel')
          }
        });
      }
    },

    openAddImsUserMemberPage() {
      const userid = this.getCheckedVals(true);
      if (userid) {
        const rtttypeList = userid.filter((item) => item.rtttype === 2 || item.rtttype === 5 || item.rtttype === 8);
        if (rtttypeList && rtttypeList.length > 0) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.notAddNetgate')});
        }
        else{
          this.$refs.addUserMemberPage.show();
          this.$refs.addUserMember.mainHandler();
        }
      }
    },
    closeAddImsUserMemberPage() {
      this.$refs.addUserMemberPage.clear();
      this.$refs.addUserMemberPage.close();
    },
    saveAddImsUserMemberPage() {
      const userSelecteds = this.$refs.grid.getSelectedRecords();
      // 拼写隶属关系数据
      const groupList = this.$refs.addUserMember.getCheckedData();
      let dymaticgroup = false;
      groupList.forEach(item => {
        if(item.grpproperty === 1){
          dymaticgroup = true;
        }
      });
      if(dymaticgroup === true){
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.notAddDynamicsTip')});
        return;
      }
      if (groupList.length === 0) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.chooseGroupDataTip')});
      } else {
        this.$loading.showLoadding(this.$t('SubscriberIms.addGroupMember'),this.$t('SubscriberIms.waitTip'));
        console.log(this.$refs.addUserMember.$refs.memeberConfigInfo.getDatas());
        const grpnum = [];
        const usrnum = [];
        const resultObj = [];
        userSelecteds.forEach(item => {
          const usrinfo = {};
          usrinfo.impu = item.impu;
          usrinfo.impugrppriority = this.$refs.addUserMember.$refs.memeberConfigInfo.getDatas().get('impugrppriority');
          usrinfo.grpproperty = this.$refs.addUserMember.$refs.memeberConfigInfo.getDatas().get('grpproperty');
          usrinfo.impugrpclass = this.$refs.addUserMember.$refs.memeberConfigInfo.getDatas().get('impugrpclass');
          usrnum.push(usrinfo);
        });
        groupList.forEach(item => {
          grpnum.push(item.grpnum);
        });
        let i = 0,
          j = 0;
        const grplen = grpnum.length;
        const impulen = usrnum.length;
        for (;i < grplen; i++) {
          for (;j < impulen; j++) {
            resultObj.push({ operObj: `${this.$t('SubscriberIms.groupNo')}${grpnum[i]}，${this.$t('SubscriberIms.userNo')}${usrnum[j].impu}` }); // 组号：xxx，用户号：xxx
          }
          j = 0;
        }
        const logParam = {
          module: 'res.subscriber#res.subscriber_ims#subscriber.imsUser',
          execFunName:'subscriber.addGroupMember',
          exectype:1,
          execData:resultObj
        };
        const param = {
          vo: { grpcount: grpnum.length, homeid: 0, grpnums: grpnum, usercount: usrnum.length, resultList: usrnum },
          info: { neid: this.info.neid, msgid: this.taskMsgid.addUserMemberMsgid },
          log:logParam
        };
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', param).then((response) => {
          /*this.$refs.addUserMemberPage.clear();
          this.$refs.addUserMemberPage.close();*/
          this.$loading.hideLoadding();
          this.$refs.dialogListPage.show();
          response.data.resultVal.forEach((item, index) => {
            resultObj[index].operResult = item.display;
            resultObj[index].operCode = item.code;
          });
          this.$refs.dialogList.addOperetionResultList(resultObj);
        });
      }
    },

    /**
     * 打开/关闭/保存  组成员查询页面
     */
    openQryImsUserMemberPage() {
      const userid = this.getCheckedVals();
      if (userid) {
        this.$refs.modUserMemberPage.show();
        this.$refs.modUserMember.getGridData(userid[0].impu, this.info.vpnid);
      }
    },
    closeModImsGroupMemberPage() {
      this.$refs.modUserMemberPage.clear();
      this.$refs.modUserMemberPage.close();
    },

    /**
     * 打开/关闭/保存  高级搜索页面
     */
    clearQryParam()
    {
      this.qrySearchBak = null;
    },
    openQryImsUserPage() {
      this.$refs.qryImsUser.clearData();
      this.$refs.qryImsUser.setData(this.qrySearchBak);
      this.$refs.qryImsUserPage.show();
    },
    qryImsUserPage() {
      const param = this.$refs.qryImsUser.getFormValue();
      this.qrySearchBak = { ...param };
      this.getGridData(this.node);
      this.$refs.qryImsUserPage.clear();
      this.$refs.qryImsUserPage.close();
    },
    closeQryImsUserPage() {
      this.$refs.qryImsUserPage.clear();
      this.$refs.qryImsUserPage.close();
    },
    /**
     * 导入
     */
    openImportUserPage() {
      document.getElementsByClassName('e-file-select-wrap')[0].querySelector('button').click();
      return false;
    },
    async onFileSelect(args) {
      if (args.filesData[0].type === 'xlsx' || args.filesData[0].type === 'xls') {
        if (this.isChooseNe() === false) {
          return;
        }
        const uploadFile = document.getElementById('file').files[0];
        this.$loading.showLoadding(this.$t('SubscriberIms.importdata'),this.$t('SubscriberIms.waitTip'));
        this.dataForm = [];//重新初始化
        await this.file2Xce(uploadFile).then(tabJson => {
          if (tabJson && tabJson.length > 0) {
            console.log(tabJson);
            const n = this.$t('SubscriberIms.userNumTitle');
            console.log(n);
            tabJson[0].sheet.forEach((item, index, arr) => {
              console.log(index);
              this.dataForm[index] = item[n]; // 需要的值的表头
            });
            // console.log(JSON.stringify(this.dataForm));
          }
        });
        if (this.dataForm.length === 0) {
          this.$loading.hideLoadding();
          this.$refs.importUser.clearAll();
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.noDataCanOper') });
          return;
        }
        // const uploadFile = document.getElementById('file').files[0];
        const formData = new FormData();
        const logParam = {
          module: 'res.subscriber#res.subscriber_ims#subscriber.imsUser',
          execFunName:'subscriber.importuser',
          exectype:1,
          //execData:[vodata]
        };
        formData.append('neid', this.info.neid);
        formData.append('operation', 'impu');
        formData.append('file', uploadFile);
        formData.append('log',JSON.stringify(logParam));
        const config = {
          timeout: 1000 * 60 * 31,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        const _showDatas = [];
        this.dataForm.forEach((item) => {
          const showData = {};
          showData.operObj = item;
          _showDatas.push(showData);
        });
        console.log('grpnums=', _showDatas);
        // 下发任务
        this.$axios.post('/lte/ems/subscriber/imsunms/importData', formData, config).then((response) => {
          this.$refs.importUser.clearAll();
          console.log(response);
          if (response.status === 200) {
            this.$loading.hideLoadding();
            if (response.data.resultVal && response.data.resultVal.length > 0) {
              this.$refs.dialogListPage.show();
              response.data.resultVal.forEach((item, index) => {
                _showDatas[index].operResult = item.display;
                _showDatas[index].operCode = item.code;
              });
              this.$refs.dialogList.addOperetionResultList(_showDatas);
              this.getGridData(this.node);
            } else {
              EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
            }
          } else {
            this.$loading.hideLoadding();
            EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
          }
        });
      } else {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.impFileTypeErrTip') });
      }
    },
    onSelected(args) {
      if (args.filesData && args.filesData.length > 0) {
        if (args.filesData[0].type !== 'xlsx' && args.filesData[0].type !== 'xls') {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.impFileTypeErrTip') });
        }
      }
    },
    async onUpload(args) {
      // 调用导入ajax方法
      if (args.fileData) {
        const { fileData } = args;
        if (args.fileData.type !== 'xlsx' && args.fileData.type !== 'xls') {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.impFileTypeErrTip') });
          args.cancel = true;
        } else {
          const uploadFile = document.getElementById('file').files[0];
          this.$loading.showLoadding(this.$t('SubscriberIms.importdata'),this.$t('SubscriberIms.waitTip'));
          await this.file2Xce(uploadFile).then(tabJson => {
            if (tabJson && tabJson.length > 0) {
              console.log(tabJson);
              const n = this.$t('SubscriberIms.userNumTitle');
              tabJson[0].sheet.forEach((item, index, arr) => {
                this.dataForm[index] = item[n]; // 需要的值的表头
              });
              console.log(JSON.stringify(this.dataForm));
            }
          });
          if (this.dataForm.length === 0) {
            this.$loading.hideLoadding();
            EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.noDataCanOper') });
            return;
          }
          const config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          const formData = new FormData();
          formData.append('neid', this.info.neid);
          formData.append('operation', 'impu');
          formData.append('file', fileData.rawFile);
          const $this = this;
          const _showDatas = [];
          this.dataForm.forEach((item) => {
            const showData = {};
            showData.operObj = item;
            _showDatas.push(showData);
          });
          this.$axios.post('/lte/ems/subscriber/imsunms/importData', formData, config).then((response) => {
            $this.$refs.importUser.clearAll();
            $this.$loading.hideLoadding();
            if (response && response.status === 200) {
              console.log(response);
              if (response.data.errorCode === '0' || response.data.errorCode === 'SUCCESS') {
                $this.$refs.dialogList.data = response.data;
                $this.$refs.dialogListPage.show();
                response.data.resultVal.forEach((item, index) => {
                  _showDatas[index].operResult = item.errorCode;
                  _showDatas[index].operCode = item.code;
                });
                $this.$refs.dialogList.addOperetionResultList(_showDatas);
                $this.getGridData(this.node);
              } else {
                EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
              }
            } else {
              EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
            }
          });
        }
      }
      args.cancel = true;
    },
    file2Xce(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: 'binary'
          });
          const result = [];
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            });
          });
          resolve(result);
        };
        // reader.readAsBinaryString(file.raw)
        reader.readAsBinaryString(file); // 传统input方法
      });
    },
    closeLayerTipPage() {
      this.$refs.layerDialog.close();
    },
    closeDialogListTipPage() {
      this.$refs.dialogListPage.clear();
      this.$refs.dialogListPage.close();
    },
    exportImsUser(jsoninfo = []) {
      if (this.info.vpnid === undefined || this.info.vpnid === '') {
        EventBus.$emit('toast', {type: 'warning', content:this.$t('SubscriberIms.checkVpnTip')});
        return;
      }

      const qryParam = this.qrySearchBak ? this.qrySearchBak : { impu: '', username: '', userenable:-1, rtttype:-1, flag: 2 };

      const exportParam = {
        info: {
          neid: this.info.neid,
        },
        vo: {
          ...qryParam,
          vpnid: this.info.vpnid,
          vpnClass: this.info.vpnClass,
        },
        operation: 'impu',
        log: {
          module: 'res.subscriber#res.subscriber_ims#subscriber.imsUser',
          execFunName:'subscriber.exportuser',
          exectype:1,
        },
      };
      const config = { responseType: 'blob' };

      this.$loading.showLoadding(this.$t('SubscriberIms.exportdata'),this.$t('SubscriberIms.waitTip'));
      this.$axios.post('/lte/ems/subscriber/imsunms/exportDataR', exportParam, config).then((res) => {
        const link = document.createElement('a');
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        const dateStr = new Date().Format('yyyy-MM-dd HH:mm');
        const fileName = `${this.$t('SubscriberIms.user')}_${dateStr}.xls`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$loading.hideLoadding();
      });
    },
  },

};
</script>

<style scoped>

</style>
